import { isMultiLoginTarget } from '@app/multiLogin/isMultiLoginTarget';
import { MultiLoginResponse } from '@app/multiLogin/types';
import { Link } from '@app/router/constants/Link';
import User from '@models/user/User';

export function createIsMultiLoginResponse(isMultiLoginTarget: boolean) {
    return function isMultiLoginResponse(user: Nullable<User & MultiLoginResponse>): user is User & Required<MultiLoginResponse> {
        return isMultiLoginTarget && !!user?.redirect;
    };
}

export const isMultiLoginResponse = createIsMultiLoginResponse(isMultiLoginTarget);

export function createGetMultiLoginDestination(isMultiLoginTarget: boolean, forbiddenPaths: string[]) {
    return function (destination: URL): string | null {
        if (!isMultiLoginTarget) {
            return null;
        }
        let href = destination.href;
        forbiddenPaths.forEach((path) => {
            if (href.endsWith(path)) {
                href = href.replace(path, '');
            }
        });

        return encodeURIComponent(href);
    };
}
export const getMultiLoginDestination = createGetMultiLoginDestination(
    isMultiLoginTarget,
    [
        Link.App.NotAuthorized,
        Link.App.NotFound,
    ],
);

export function getMultiLoginQuery(multiLoginDestination: string | null): string {
    return multiLoginDestination ? `?type=multi&destination=${multiLoginDestination}` : '';
}
